function pushHighlight(map, assetId, eventId) {
  if (!assetId || !eventId) {
    return;
  }
  if (!map[assetId]) {
    map[assetId] = [];
  }
  if (!map[assetId].includes(eventId)) {
    map[assetId].push(eventId);
  }
}

// Preview still calls notificationsMarkAsRead(assetId). Only unread ids belong
// here — read cards stay in the feed and must not decrement the bell again.
export default function collectUnreadHighlights(events = []) {
  const newComments = {};
  const newRevisions = {};

  events.forEach((item) => {
    if (item.read) {
      return;
    }
    const assetId = item.data?.asset?._id;
    if (item.type === 'asset.comment.added') {
      pushHighlight(newComments, assetId, item._id);
    }
    if (item.type === 'asset.revision.created') {
      pushHighlight(newRevisions, assetId, item._id);
    }
  });

  return { newComments, newRevisions };
}
